export enum AppComponentApiIdsEnum {
    CONTACT_DETAIL = 'CONTACT_DETAIL',
    FAVORITE_DOCUMENT_LIST = 'FAVORITE_DOCUMENT_LIST',
    IN_PROGRESS_LIST = 'IN_PROGRESS_LIST',
    LAST_EDITED_LIST = 'LAST_EDITED_LIST',
    MAGNET_DOCUMENT_LIST = 'MAGNET_DOCUMENT_LIST',
    MAGNET_TASK_DOCUMENT_LIST = 'MAGNET_TASK_DOCUMENT_LIST',
    NEWEST_DOCUMENT_LIST = 'NEWEST_DOCUMENT_LIST',
    RECYCLE_BIN_DOCUMENT_LIST = 'RECYCLE_BIN_DOCUMENT_LIST',
    TOP_LEVEL_VAULT_DOCUMENT_LIST = 'TOP_LEVEL_VAULT_DOCUMENT_LIST',
    VAULT_LIST = 'VAULT_LIST',
}
